export default __webpack_public_path__ + "static/media/thumbnail3.84fade22.jpg";